// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import SlimSelect from "slim-select";

export default class SelectDesign extends WebComponent {
  didMount() {

    let messages = {
      cs: {
        searchText: 'Nic jsme nenašli..',
        searchPlaceholder: 'Vyhledat',
      },
      en: {
        searchText: 'We didn\'t find anything...',
        searchPlaceholder: 'Search',
      },
      de: {
        searchText: 'Wir haben nichts gefunden...',
        searchPlaceholder: 'Suchen',
      }
    }

    let showSearchValue = false;
    if(this.element.dataset.showSearch) {
      showSearchValue = this.element.dataset.showSearch;
    }

    if (this.element.tagName === 'SELECT') {
      let select = new SlimSelect({
        select: this.element,
        showSearch: showSearchValue,
        option: {
          html: '<b>html</b>',
        },
        searchText: messages[window.projectConfig.lang].searchText,
        searchPlaceholder: messages[window.projectConfig.lang].searchPlaceholder,
        searchHighlight: true,
      });

      if(this.element.dataset.showSearch) {
        let placeholderSelected = '';
        let ssIOptionSelected = this.element.parentNode.querySelector('.ss-option-selected');
        let selectData = select.data;
        for(let i = 0; i < selectData.data.length; i++) {
          let sData = selectData.data[i];
          if(ssIOptionSelected.dataset.id === sData.id) {
            placeholderSelected = `${sData.value}, ${sData.text.replace(sData.value, '').replace('(', '').replace(')', '')}`;
          }
          sData.innerHTML = `${sData.value} <small>${sData.text.replace(sData.value, '')}</small>`;
        }
        select.setData(selectData.data);

        let placeholder = this.element.parentNode.querySelector('.placeholder');
        setTimeout(() => {
          if(placeholder) {
            placeholder.innerHTML = placeholderSelected;
          }
        }, 0);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SelectDesign.js